import { render, staticRenderFns } from "./laowu.vue?vue&type=template&id=1d6b3a0a&scoped=true&"
import script from "./laowu.vue?vue&type=script&lang=js&"
export * from "./laowu.vue?vue&type=script&lang=js&"
import style0 from "./laowu.vue?vue&type=style&index=0&id=1d6b3a0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b3a0a",
  null
  
)

export default component.exports